/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import {
  ICommonProductDetails,
  IProductDetails,
  ProductPreviewTypes,
} from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useProductHasAttrs } from "@/hooks/product-has-attrs/useProductHasAttrs";
import { useIsMobile } from "@/hooks/useIsMobile";
import useProductPopup from "@/hooks/useProductPopup";
import { Col, Row } from "@/utils/bootstrap";
import { useEffect, useMemo, useRef, useState } from "react";
import Price from "../../lib/Price";
import BreadCrumb from "../../lib/breadcrumb/BreadCrumb";
import { Link } from "../../lib/navigation/Link";
import SocialShareBtns, {
  ShareIconTypes,
} from "../common/social-share-btns/SocialShareBtns";
import { debounce } from "../cart/cart-functions";
import Notes from "./details-belpers/Notes/Notes";
import { getVariantImageSource } from "./details-belpers/product-attributes/helpers/functions";
import ProductMainInfo from "./details-belpers/ProductMainInfo";
import SliderWithThumbs from "./details-belpers/SliderWithThumbs";
import Units from "./details-belpers/Units";
import AddOns from "./details-belpers/product-addons/AddOns";
import Attributes from "./details-belpers/product-attributes/Attributes";
import SpecificProduct from "./details-belpers/specific-product/SpecificProduct";
import { useForm } from "react-hook-form";
import dynamic from "next/dynamic";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import {
  defaultValues,
  renameFields,
  adaptFieldsToPost,
} from "../../common-form-builder/form-builder-helpers/form-functions";

import useCanTabby from "@/hooks/useCanTabby";

import useRobosize from "@/hooks/useRobosize";
import useCanTamara from "@/hooks/useCanTamara";

import useSellingMode from "@/hooks/useSellingMode";

import { useWishlist } from "@/hooks/useWishlist";
import { IProductTheme } from "@/api/AppApi/services/company/interfaces/ICompany";

import SVGSizeChartIcon from "./size-chart/SVGSizeChartIcon";

import useCanTaly from "@/hooks/useCanTaly";


const AgreeTermsCheckbox = dynamic(
  () => import("../common/agree-terms/AgreeTermsCheckbox"),
  { ssr: false },
);

const TabbyPromo = dynamic(
  () => import("../../lib/Tabby").then((mod) => mod.TabbyPromo),
  { ssr: false },
);
const ProductDetailsPriceInfo = dynamic(
  () =>
    import("./details-belpers/product-details-price-info/ProductDetailsPriceInfo"),
  { ssr: false },
);
const ProductOtherFields = dynamic(
  () => import("./details-belpers/ProductOtherFields"),
  { ssr: false },
);
const TamaraPromo = dynamic(() => import("../../lib/Tamara/TamaraPromo"), {
  ssr: false,
});
const EventDetails = dynamic(() => import("./Events/EventDetails"), {
  ssr: false,
});
const BundleItems = dynamic(() => import("./bundle/BundleItems"), {
  ssr: false,
});
const StockAlertMessage = dynamic(
  () => import("./details-belpers/StockAlertMessage"),
  { ssr: false },
);
const SizeChartModal = dynamic(() => import("./size-chart/SizeChartModal"), {
  ssr: false,
});
const TalyPromo = dynamic(() => import("../../lib/Taly/TalyPromo"), {
  ssr: false,
});
const TryOnMeButton = dynamic(() => import("./virtual-try-on/TryOnMeButton"), {
  ssr: false,
});
const VirtualTryOnModal = dynamic(
  () => import("./virtual-try-on/VirtualTryOnModal"),
  { ssr: false },
);

const DetailsSpec = dynamic(
  () => import("./details-belpers/details-specefications/DetailsSpec"),
  { ssr: false },
);

interface Props {
  product: ICommonProductDetails;
  popup?: "normal" | "configrable" | false;
  AttrbuitesInitialValues?: number[];
  productSettings?: IProductTheme;
}

const ProductDetails: React.FC<Props> = ({
  product,
  popup = false,
  AttrbuitesInitialValues,
  productSettings,
}) => {
  useRobosize({ product: product as IProductDetails });
  const form = useForm<any>();
  const [fields, setFields] = useState<Array<IField>>([]);
  const mobile = useIsMobile();
  const t = useTranslation();
  const { handleClosePopup } = useProductPopup();
  const getComapny = useGetCompanyQuery();
  const {
    show_specification_section,
    show_all_product_units,
    auto_select_first_child_in_show_product,
    show_low_stock_alert,
    min_stock_quantity_to_show_alert,
    allow_user_request_stock_availability_reminder,
  } =
    productSettings ??
    getComapny?.data?.result?.theme?.components?.product ??
    {};
  const prodState = useProductHasAttrs(product);
  const {
    currentProd,
    note,
    selectedAddOns,
    setSelectedChildIndex,
    handleNoteChange,
    handleSelectedAddOnsChanged,
    cartDisabled,
    otherInputs,
    selectedUnitId,
    selectedUnit,
    handleSelectUnits,
    getPrise,
    outOfStock,
    isDisabled,
    cartItemId,
    disablechangeAddon,
    setSelectedBundleItems,
    selectedBundleItems,
    handleOtherInputsChange,
    isCartUpdating,
    selectedAttributesValues,
    setSelectedAttributesValues,
  } = prodState;

  // Gallery follows partial selections too (e.g. colour picked, size not yet).
  const galleryImageSource = useMemo(
    () =>
      getVariantImageSource(
        product,
        selectedAttributesValues,
        currentProd !== product ? currentProd : null,
      ),
    [product, selectedAttributesValues, currentProd],
  );
  const galleryImages = galleryImageSource.images;

  const [currentInitValues, setCurrentInitValues] = useState<
    number[] | undefined
  >(AttrbuitesInitialValues);

  const fieldsBuilder = (currentProd || product)?.fields_builder;
  const detailsCountainerRef = useRef<HTMLDivElement>(null);
  const [detailsCountaineMaxWidth, setdDtailsCountaineMaxWidth] = useState(0);
  const canTabby = useCanTabby();
  const canTamara = useCanTamara();
  const canTaly = useCanTaly();

  const units = currentProd.units;
  const breadCrumb = (
    <BreadCrumb
      hierarchy={
        product?.breadcrumb?.map((crumb) => ({
          text: crumb.name,
          link:
            crumb.type === "category"
              ? `/categories/${crumb.slug}`
              : `/products/${crumb.slug}`,
        })) || [{ text: product?.name }]
      }
    />
  );
  const mClass = mobile ? "-mobile" : "";
  const ispopup = !!popup;
  const isConfigrablePopup = popup === "configrable";
  const isPopupMobile = mobile && ispopup;
  const showNoteField = !cartDisabled && Boolean(currentProd?.show_note_field);
  const { isFavorite, toggle } = useWishlist(
    currentProd?.id,
    currentProd?.is_favorite as boolean,
  );
  useEffect(() => {
    if (!prodState) return;
    const getKey = (str: string) => {
      const string = str.split(".");
      return string[string.length - 1];
    };
    const initFields = new Array<IField>();
    fieldsBuilder?.forEach((field) => {
      initFields?.push({
        ...field,
        value: otherInputs?.[getKey(field?.configurations?.key)],
      });
    });
    const fields = renameFields(initFields);
    const newValues = defaultValues(fields);
    const currentValues = form.getValues();

    // Only reset the form if the values actually changed from outside to avoid losing focus while typing
    if (JSON.stringify(newValues) !== JSON.stringify(currentValues)) {
      form.reset(newValues);
    }

    setFields(fields!);
    setdDtailsCountaineMaxWidth(detailsCountainerRef?.current?.clientWidth!);
  }, [otherInputs, currentProd]);

  useEffect(() => {
    const subscription = form.watch(
      debounce((value: any) => {
        const formattedData = adaptFieldsToPost(value);
        handleOtherInputsChange(formattedData);
      }, 1000),
    );
    return () => subscription.unsubscribe();
  }, [form.watch, handleOtherInputsChange]);
  const termAndCondition = currentProd?.custom_data?.term_and_condition;
  const isService =
    currentProd.preview_type === ProductPreviewTypes.appointment ||
    currentProd.preview_type === ProductPreviewTypes.consultation;
  const [agree, setAgree] = useState(!(!!termAndCondition && !isService));

  const showMinStockQuantityMsg =
    show_low_stock_alert &&
    currentProd.quantity_on_hand <= min_stock_quantity_to_show_alert! &&
    !outOfStock &&
    !isDisabled;

  useEffect(() => {
    if (
      selectedUnit?.min_quantity_in_cart &&
      selectedUnit?.min_quantity_in_cart > 0
    )
      form.setValue("quantity", selectedUnit?.min_quantity_in_cart);
  }, [selectedUnitId]);

  const { enableAddToCart } = useSellingMode();
  const showRate =
    (productSettings ?? getComapny?.data?.result?.theme?.components?.product)
      ?.product_reviews_visibility !== "not_visible";
  const [showSizeChart, setShowSizeChart] = useState(false);
  const [showVirtualTryOn, setShowVirtualTryOn] = useState(false);
  const [modalInitValues, setModalInitValues] = useState<number[] | undefined>(
    AttrbuitesInitialValues,
  );

  const handleOpenVirtualTryOn = () => {
    setModalInitValues(
      selectedAttributesValues?.length > 0
        ? selectedAttributesValues
        : currentInitValues,
    );
    setShowVirtualTryOn(true);
  };

  const showTryOnMeButton = currentProd?.enable_try_on;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: isPopupMobile ? 0 : 24,
      }}
    >
      {!popup && !mobile && (
        <div style={{ marginBottom: mobile ? 52 : 0 }}>{breadCrumb}</div>
      )}
      <Row
        className={`m-0 ${
          isPopupMobile ? "product-details-pop-up-mobile" : ""
        }`}
        style={{
          // gap: mobile ? 24 : 32,
          height: isPopupMobile ? "100%" : "auto",
        }}
      >
        {!isConfigrablePopup && (
          <Col
            className={`${mobile ? "p-0" : ""}`}
            lg={galleryImages?.length > 1 ? 5 : 4}
          >
            <div
              className={`${
                !popup ? "product-details-slider-container" + mClass : ""
              }`}
            >
              <SliderWithThumbs
                key={galleryImageSource.id}
                productImages={galleryImages}
                id={currentProd?.id}
                isPC={!mobile}
                isSmall={ispopup}
                productName={currentProd?.name}
                isFavorite={isFavorite}
                onToggleFavorite={toggle}
              />
            </div>
            {!mobile && <SocialShareBtns type={ShareIconTypes.product} />}
            {ispopup && (
              <div className={`see-details-link${isPopupMobile ? mClass : ""}`}>
                <Link
                  prefetch={false}
                  href={`/products/${product.slug}${
                    cartItemId ? `?cart_item_referer=${cartItemId}` : ""
                  }`}
                  onClick={handleClosePopup}
                >
                  {t.see_details}
                </Link>
              </div>
            )}
          </Col>
        )}
        <Col
          className={`${mobile ? "p-0 pt-2 " : ""}`}
          lg={
            mobile
              ? { span: true }
              : isConfigrablePopup
                ? 12
                : galleryImages?.length > 1
                  ? 7
                  : 8
          }
        >
          <div
            ref={detailsCountainerRef}
            className={`product-details-container${
              ispopup ? "-pop-up" : mClass
            }`}
            style={
              isPopupMobile || isConfigrablePopup
                ? {
                    maxWidth: "100%",
                    justifyContent: "space-between",
                  }
                : {}
            }
          >
            <ProductMainInfo
              showRate={!!showRate}
              product={currentProd}
              isConfigrablePopup={isConfigrablePopup}
              getPrise={getPrise}
              link={
                isConfigrablePopup && (
                  <div
                    className={`see-details-link${isPopupMobile ? mClass : ""}`}
                    style={{ paddingTop: 0, lineHeight: "inherit" }}
                  >
                    <Link
                      prefetch={false}
                      href={"/products/" + product.slug}
                      onClick={handleClosePopup}
                    >
                      {t.see_details}
                    </Link>
                  </div>
                )
              }
            />
            {currentProd.preview_type === ProductPreviewTypes.event && (
              <EventDetails
                {...currentProd.custom_data!}
                price={currentProd.price}
                price_without_discount={currentProd.price_without_discount}
                special_prices={currentProd.selling_prices}
                justifyContentStart
              />
            )}
            {enableAddToCart && (
              <h2 className="m-0 p-0">
                <Price
                  gap={10}
                  priceFirst
                  price={{
                    value: getPrise("price") as number,
                    className: "price",
                  }}
                  priceWithoutDiscount={{
                    value: getPrise("price_without_discount") as number,
                    className: "price-without-discount",
                  }}
                  roundPrice
                  discountAmount={getPrise("discount_amount") as number}
                />
              </h2>
            )}
            {!!product?.size_chart && (
              <>
                <div
                  id={`size-chart-btn-${product.id}`}
                  className="size-chart-btn"
                  onClick={() => setShowSizeChart(true)}
                >
                  <SVGSizeChartIcon />
                  <span>{t.size_chart}</span>
                </div>
                <SizeChartModal
                  show={showSizeChart}
                  onHide={() => setShowSizeChart(false)}
                  sizeChart={product.size_chart!}
                />
              </>
            )}
            {showMinStockQuantityMsg && (
              <StockAlertMessage
                minStockQuantity={currentProd.quantity_on_hand}
              />
            )}
            {(canTamara || canTabby || canTaly) && (
              <div
                className="d-flex flex-column"
                style={{ maxWidth: 590, gap: 24 }}
              >
                {canTamara && (
                  <TamaraPromo price={getPrise("price") as number} />
                )}
                {canTabby && (
                  <TabbyPromo
                    price={getPrise("price") as number}
                    source="product"
                  />
                )}
                {canTaly && <TalyPromo price={getPrise("price") as number} />}
              </div>
            )}
            {currentProd?.selling_prices?.length > 1 && (
              <ProductDetailsPriceInfo
                productSpecialPrice={currentProd.selling_prices}
              />
            )}
            {showTryOnMeButton && (
              <TryOnMeButton
                onClick={handleOpenVirtualTryOn}
                fullWidth={mobile}
              />
            )}
            {currentProd.bundle_items &&
              currentProd.bundle_items?.length > 0 && (
                <BundleItems
                  items={currentProd.bundle_items}
                  setSelectedBundleItems={setSelectedBundleItems}
                  selectedBundleItems={selectedBundleItems}
                />
              )}
            {product?.attributes_builder?.length > 0 && (
              <div id="attributes-selector">
                <Attributes
                  product={product}
                  setSelectedChildIndex={setSelectedChildIndex}
                  autoSelectFirstChild={
                    auto_select_first_child_in_show_product!
                  }
                  detailsCountaineMaxWidth={detailsCountaineMaxWidth}
                  initialValues={currentInitValues}
                  setSelectedAttributesValues={setSelectedAttributesValues}
                  allow_user_request_stock_availability_reminder={
                    allow_user_request_stock_availability_reminder
                  }
                />
              </div>
            )}
            {!currentProd.is_configurable &&
              currentProd?.addons_builder?.length > 0 && (
                <AddOns
                  addOnBiulder={currentProd.addons_builder}
                  state={selectedAddOns}
                  setState={handleSelectedAddOnsChanged}
                  detailsCountaineMaxWidth={detailsCountaineMaxWidth}
                  disablechangeAddon={disablechangeAddon}
                  productId={currentProd.id}
                />
              )}
            {show_all_product_units && !outOfStock && (
              <Units
                units={units}
                selectedUnitId={selectedUnitId!}
                onSelect={handleSelectUnits}
              />
            )}
            {fields &&
              fields?.length > 0 &&
              product?.preview_type !== ProductPreviewTypes.consultation && (
                <ProductOtherFields
                  fields={fields}
                  form={form}
                  disabled={isCartUpdating}
                />
              )}
            {showNoteField && (
              <Notes
                notes={note}
                setNotes={handleNoteChange}
                disabled={cartDisabled || isCartUpdating}
              />
            )}
            {termAndCondition && !isService && (
              <AgreeTermsCheckbox
                checked={agree}
                setChecked={setAgree}
                terms={termAndCondition}
              />
            )}
            {!isConfigrablePopup && mobile && (
              <SocialShareBtns type={ShareIconTypes.product} />
            )}
            <SpecificProduct
              form={form}
              agreeTerms={agree}
              productState={prodState}
              isPopupMobile={isPopupMobile}
              popup={popup}
            />
          </div>
        </Col>
      </Row>
      {!ispopup && show_specification_section && (
        <DetailsSpec
          html={currentProd?.long_description}
          spec={currentProd?.specifications}
          showRate={showRate}
          rate={product?.rate}
          ratings={product?.ratings}
          canReview={product?.can_review}
          productId={product?.parent_id ?? product?.id}
        />
      )}
      <VirtualTryOnModal
        show={showVirtualTryOn}
        onHide={() => {
          setShowVirtualTryOn(false);
          setCurrentInitValues(selectedAttributesValues);
        }}
        product={product}
        productState={prodState}
        form={form}
        productSettings={productSettings}
        agreeTerms={agree}
        detailsCountaineMaxWidth={detailsCountaineMaxWidth}
        AttrbuitesInitialValues={modalInitValues}
        fields={fields}
      />
    </div>
  );
};

export default ProductDetails;
